










import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import providers from "@/lib/api";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { personalInfoFields } from "../config";

@Component({ name: "PersonalInfoForm", components: { BaseForm } })
export default class PersonalInfoForm extends mixins(WithAuthUser) {
  @Prop({ default: false })
  public editMode!: boolean;

  public personalInformation: PersonalInformation | null = null;

  public values: FormValues = {
    firstName: "",
    lastName: "",
    phone: "",
  };

  get personalInfoFields(): FormFields {
    return this.editMode ? personalInfoFields.filter(e => e.name === "phone") : personalInfoFields;
  }

  public async getData() {
    await providers.PersonalInformationProvider.find({ id: this.authUserStrict.id }).then(r => {
      this.personalInformation = r;
      this.values = {
        firstName: this.personalInformation.firstName,
        lastName: this.personalInformation.lastName,
        phone: this.personalInformation.phone,
      };
    });
  }

  public async submitPersonalInfo() {
    const data = {
      userId: this.authUserStrict.id,
      phone: this.values.phone,
    };
    this.personalInformation = await providers.PersonalInformationProvider.update({ data });
    this.values = {
      ...this.values,
      firstName: this.personalInformation.firstName,
      lastName: this.personalInformation.lastName,
      phone: this.personalInformation.phone,
    };
  }

  public async created() {
    this.$emit("setValid", true);
    this.$emit("setCb", () => this.submitPersonalInfo());
    try {
      this.$emit("setLoading", true);
      await this.getData();
    } finally {
      this.$emit("setLoading", false);
    }
  }
}
